import styled from 'styled-components';

import { TextBox } from '@ecp/common/src/text/TextBox';

const StyledTextBox = styled(TextBox)`
  font-size: 13px;
  font-weight: 350;
`;

const StyledAtag = styled.a`
  font-size: 12px;
  font-weight: 350;
  color: inherit;
  text-decoration: none;
  line-height: inherit;
  background-color: unset;
  white-space: pre-wrap;
`;

export { StyledTextBox, StyledAtag };
